import { Bandeira } from './bandeira.enum';
import { TipoPlanoEnum } from './novo-plano-renegociacao.model';


export enum StatusLinkPagamentoCelerEnum {
  AGUARDANDO_PAGAMENTO = 'AGUARDANDO_PAGAMENTO',
  PAGO = 'PAGO',
  EXPIRADO = 'EXPIRADO',
  CANCELADO = 'CANCELADO',
}

export enum TipoContratoEnum {
  SEGUNDA_VIA = 'SEGUNDA_VIA',
  REPLANIFICACAO = 'REPLANIFICACAO',
}

export enum TipoPagamentoCeler {
  PIX = 'PIX',
  CARTAO = 'CARTAO'
}

export interface PagamentoCeler {
  contrato: string;
  tipoContrato: TipoContratoEnum;
  tipoPlano: TipoPlanoEnum;
  quantidadeParcelas: number;
  parcelaPagamento: number;
  valorPagamento: number;
  urlRedirecionamento: string;
  bandeira: Bandeira;
  vencimentoParcela: string;
  valorParcelaOriginal: number;
  codigoBoleto: string;
  contaBoleto: string;
}

export interface PagamentoCelerLinkResponse {
  url: string;
  dataExpiracao: string;
  codigo: string;
  qrCode: string;
}
